import { render, staticRenderFns } from "./ProducersWithoutAccess.vue?vue&type=template&id=2087d48e&scoped=true&"
import script from "./ProducersWithoutAccess.vue?vue&type=script&lang=js&"
export * from "./ProducersWithoutAccess.vue?vue&type=script&lang=js&"
import style0 from "./ProducersWithoutAccess.vue?vue&type=style&index=0&id=2087d48e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2087d48e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VDivider,VIcon,VRow})
